import VerificationCodeModal from "./verification-code-modal.component";

export default VerificationCodeModal;
